// src/utils/constants.js
//export const API_BASE_URL = 'http://localhost:8080/api';
export const API_BASE_URL = 'https://brasotechgobackend-production.up.railway.app/api';


export const SERVICE_CATEGORIES = [
  'MINING',
  'MECHANICAL',
  'ELECTRICAL',
  'CIVIL SERVICES',
  'PRODUCTS SUPPLIES',
  'ARCHITECTURE',
  'PRE-CONSTRUCTION',
  'GENERAL CONSTRUCTION',
  'SUPPLY OF VALVES & PUMPS',
  'SUPPLY OF TIMBER',
  'HYDRAULIC REPAIR'
];

export const COMPANY_INFO = {
  name: 'Brasotech Investments Limited',
  tagline: 'General Suppliers & Contractors',
  email: 'brasotech@gmail.com',
  phone: '+260966801731',
  address: 'Suite 140B David Mwila House, President Avenue Kitwe',
  vision: 'To become the leading Engineering and suppliers of goods and services in Zambia and eventually the continent, while delivering projects that consistently meet international standards.',
  mission: 'To develop an effective management that stresses productivity with perpetual development whilst instilling work ethics in all personnel.',
  coreValues: [
    'Honesty and Integrity',
    'Customer Service',
    'Quality',
    'Teamwork'
  ]
};